import React, { useState } from "react";
import "../documentation.css";
import moment from "moment";
import {
  DoneIcon,
  TodoIcon,
  TabletIncompleteNotif,
  DownloadIcon
} from "../../assets/Icons";
import OverflowedText from "../../common/OverflowedText/OverflowedText";
import FadingSpinner from "../../common/FadingSpinner/FadingSpinner";
import { getLatestDate, formatTimestamp, filenameFromUrl } from "../helpers";

const DesktopDownload = ({
  getPdf,
  timestamp,
  downloadRef,
  isIncomplete = false
}) => {
  const [isDownloading, setDownloading] = useState(false);
  const handleDownloadClick = async (count = 0) => {
    setDownloading(false);
    if (!isDownloading && count < 3) {
      setDownloading(true);
      try {
        await getPdf();
        setDownloading(false);
      } catch (err) {
        setTimeout(() => {
          handleDownloadClick(count + 1);
        }, 2000);
      }
    }
  };
  return (
    <div className="reading-list__record reading-list__record-form d-flex justify-content-center">
      <span className="d-none d-md-flex d-lg-none flex-row-reverse">
        <button className="reading-list__record-form-tablet-button d-flex ml-1">
          {isDownloading ? (
            <FadingSpinner size={"sm"} />
          ) : (
            <div>
              <DownloadIcon onClick={() => handleDownloadClick()} />
            </div>
          )}
        </button>
      </span>
      <div className="tooltip">
        <button
          className="reading-list__record-form-button d-flex d-md-none d-lg-flex"
          onClick={() => handleDownloadClick()}
        >
          {/* eslint-disable-next-line */}
          {isDownloading ? (
            <FadingSpinner size={"1x"} />
          ) : isIncomplete ? (
            "See progress"
          ) : (
            "Download"
          )}
        </button>
        <span
          className={`reading-list__record-form-tablet-error d-md-block d-lg-none ${!isIncomplete &&
            "invisible"}`}
        >
          <TabletIncompleteNotif
            className={`reading-list__record-form-tablet-error-icon`}
          />
          Incomplete
        </span>
        {!isIncomplete && <div className="tooltiptext">Signed {timestamp}</div>}
      </div>
      {/* eslint-disable-next-line */}
      <a className="d-none" ref={downloadRef}></a>
    </div>
  );
};

const DesktopDocumentation = ({
  readingList,
  onlineForms,
  candidates,
  checklists,
  getFormPdf,
  getChecklistPdf,
  downloadRef
}) => (
  <section className="documentation-reading-list__body d-none d-md-block">
    <section className="documentation-reading-list__body-table">
      <header className="reading-list__header">
        <div className="reading-list__header-worker">
          <span>WORKER</span>
        </div>
        {readingList.map((doc, index) => (
          <div className="reading-list__header-document" key={index}>
            <span>{doc.title}</span>
          </div>
        ))}
        {onlineForms.map((form, index) => (
          <div
            className="reading-list__header-document reading-list__header-form"
            key={index}
          >
            <span>{form.title}</span>
          </div>
        ))}
        {checklists.map((list, index) => (
          <div
            className="reading-list__header-document reading-list__header-form"
            key={index}
          >
            <span>{list.title}</span>
          </div>
        ))}
      </header>
      <section className="reading-list">
        {candidates.map(candidate => (
          <section className="reading-list__row" key={candidate.candidateRef}>
            <div className="reading-list__person">
              <div className="reading-list__person-short">
                {candidate.firstName[0]}
                {candidate.lastName[0]}
              </div>
              <OverflowedText
                overflowedText={`${candidate.firstName} ${candidate.lastName}`}
              >
                <strong>
                  {candidate.firstName} {candidate.lastName}
                </strong>
              </OverflowedText>
            </div>
            {readingList.map((doc, i) => {
              const filename = filenameFromUrl(doc.link);
              if (
                candidate.documents &&
                candidate.documents.readings &&
                candidate.documents.readings[filename]
              ) {
                return (
                  <div className="reading-list__record" key={i}>
                    <div className="tooltip">
                      <DoneIcon />
                      <div className="tooltiptext">
                        Signed{" "}
                        {formatTimestamp(
                          candidate.documents.readings[filename]
                        )}
                      </div>
                    </div>
                  </div>
                );
              }
              return (
                <div className="reading-list__record" key={i}>
                  <TodoIcon />
                </div>
              );
            })}
            {onlineForms.map((form, i) => {
              if (
                candidate.documents &&
                candidate.documents.forms &&
                candidate.documents.forms[form.code]
              ) {
                return (
                  <DesktopDownload
                    key={i}
                    getPdf={() =>
                      getFormPdf(
                        form.code,
                        candidate.candidateRef,
                        form.title,
                        candidate.firstName,
                        candidate.lastName
                      )
                    }
                    timestamp={formatTimestamp(
                      candidate.documents.forms[form.code].timestamp
                    )}
                    downloadRef={downloadRef}
                  />
                );
              }
              return (
                <div
                  className="reading-list__record reading-list__record-form"
                  key={i}
                >
                  <TodoIcon />
                </div>
              );
            })}
            {checklists.map((list, i) => {
              if (
                candidate.documents &&
                candidate.documents.checklists &&
                candidate.documents.checklists[list.code]
              ) {
                const datesArray = Object.values(
                  candidate.documents.checklists[list.code]
                );
                const parsedDates = datesArray.flatMap(date =>
                  date ? moment(date) : []
                );
                const isIncomplete =
                  parsedDates.length > 0 && parsedDates.length < 19;
                return (
                  <DesktopDownload
                    key={i}
                    getPdf={() =>
                      getChecklistPdf(
                        candidate.candidateRef,
                        list.title,
                        candidate.firstName,
                        candidate.lastName
                      )
                    }
                    timestamp={formatTimestamp(getLatestDate(datesArray))}
                    isIncomplete={isIncomplete}
                    downloadRef={downloadRef}
                  />
                );
              }
              return (
                <div
                  className="reading-list__record reading-list__record-form"
                  key={i}
                >
                  <TodoIcon />
                </div>
              );
            })}
          </section>
        ))}
      </section>
    </section>
  </section>
);

export default DesktopDocumentation;
